/* eslint-disable react-refresh/only-export-components */
import { StatusBadge } from '@/components/molecules/StatusBadge';
import { invoiceStatusTone } from '@/components/molecules/StatusBadgeTone';
import { formatInvoiceStatusLabel } from '@/lib/invoice-status';
import type { InvoiceStatus } from '@/types/invoice';

export const INVOICE_STATUS_LABEL: Record<string, string> = {
  draft: 'Draft',
  open: 'Open',
  sent: 'Sent',
  viewed: 'Viewed',
  partial: 'Partial',
  paid: 'Paid',
  overdue: 'Overdue',
  void: 'Void',
  refunded: 'Refunded',
  written_off: 'Written off',
  clearing: 'Clearing',
};

export function InvoiceStatusBadge({ status }: { status: InvoiceStatus | string }) {
  return (
    <StatusBadge
      tone={invoiceStatusTone(status)}
      label={INVOICE_STATUS_LABEL[status] ?? formatInvoiceStatusLabel(status)}
    />
  );
}
